import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { CommonModule, NgClass } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { LinkModule } from '../web/link/link.module';
import { SizeRange } from '@bazis/shared/models/base.types';

interface IButtonOptions {
    titleKey: string;
    fill?: string;
    color?: string;
    size?: SizeRange;
    iconStart?: string;
    iconEnd?: string;
}

interface ILinkOptions {
    titleKey: string;
    href: string;
    size?: SizeRange;
    iconStart?: string;
    iconEnd?: string;
    borderStyle?: 'dotted' | 'dashed' | 'solid' | 'none';
    target?: '_blank' | '_self' | '_parent' | '_top';
}

@Component({
    selector: 'bazis-empty',
    templateUrl: './empty.component.html',
    imports: [
        IconModule,
        ButtonModule,
        ColorDirective,
        NgClass,
        TranslocoModule,
        CommonModule,
        LinkModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyComponent implements OnInit {
    readonly titleKey = input<string>();

    readonly titleParams = input<any>();

    readonly messageKey = input<string>();

    readonly messageParams = input<any>();

    readonly cssClass = input<string>('');

    readonly pathImg = input<string>();

    readonly buttonOptions = input<IButtonOptions>();

    readonly linkOptions = input<ILinkOptions>();

    buttonClick = output();

    ngOnInit() {}

    addAction(event) {
        this.buttonClick.emit(event);
    }
}
